import { Component, OnInit, OnDestroy, AfterViewInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import * as L from 'leaflet';
import { TelemetryService, VcuCoordinatesHistoryResponse, CoordinatePoint, StreamRealtimeParameter } from 'src/app/service/telemetry.service';
import { TelemetryData } from 'src/app/model/telemetry-data';
import { ProjectService } from 'src/app/service/project.service';
import { AccountService } from 'src/app/service/account.service';
import { AuthService } from 'src/app/service/auth.service';
import { PublicService } from 'src/app/public/service.service';
import { MessageService } from 'primeng/api';
import { TranslocoService } from '@ngneat/transloco';
import { GetAllPublicProjectsResponse, PaginationPublicProjects } from 'src/app/public/public-project-response';
import { ProjectSummaryResponse } from 'src/app/model/response/ProjectSummaryResponse';
import { Router } from '@angular/router';
import { sharingProjectType } from 'src/app/model/enum/sharingProjectType';
import * as QRCode from 'qrcode';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Document, Packer, Paragraph, ImageRun, AlignmentType, TextRun } from 'docx';
import { AccountResponse } from 'src/app/model/response/account-response';
import { enviroment } from 'src/environments/environment';


interface TelemetrySample {
  save: boolean;
  timestamp: string;
  values: { [key: string]: number };
}

interface TelemetryPayload {
  samples: TelemetrySample[];
  save: boolean;
  source: string;
  status: string;
  timestamp: string;
  user_id: string;
  vcu_id: string;
}

interface ProjectOption {
  deviceId: string;
  data: TelemetryPayload;
  timestamp: string;
}

@Component({
  selector: 'app-realtime-vcu',
  templateUrl: './realtime-vcu.component.html',
  styleUrls: ['./realtime-vcu.component.css']
})

export class RealtimeVcuComponent implements OnInit, OnDestroy, AfterViewInit {
  Math = Math; // Expõe Math para uso no template
  private map!: L.Map;
  private marker!: L.Marker;
  private originMarker!: L.Marker;
  private destinationMarker!: L.Marker;
  private checkpointMarker!: L.Marker;
  private parada1Marker!: L.Marker;
  private saidaMarker!: L.Marker;
  private parada2Marker!: L.Marker;
  private pathPolyline!: L.Polyline;
  private pathCoordinates: L.LatLng[] = [];
  private subscription: Subscription = new Subscription();
  private previousCarPosition: L.LatLng | null = null;
  private currentRotation: number = 0;
  
  telemetryData: TelemetryData | null = null;
  projectName: string = 'Audi A3';
  userName: string = 'Gabriel';
  eventName: string = '';
  carId: string = '';
  isConnected: boolean = false;
  hasTransmission: boolean = true;
  isTelemetryRoute: boolean = false;
  
  // Stream Realtime Parameters
  youtubeStreamUrl: string | null = null;
  dynamicVcuId: string | null = null;
  dynamicVcuId2: string | null = null; // Segundo VCU
  hasVideoStream: boolean = false;
  hasMapStream: boolean = false;
  
  // VCU que atualiza os dados de telemetria em tempo real
  private readonly TELEMETRY_VCU_ID = '0A11483028FT700 ASI';
  
  // Segundo marker para o segundo VCU
  private marker2!: L.Marker;
  private currentCarPosition2: L.LatLng | null = null;
  private previousCarPosition2: L.LatLng | null = null;
  private currentRotation2: number = 0;
  private _latitude2: number = 0;
  private _longitude2: number = 0;
  
  // Conexão SSE independente para o segundo VCU (não usa o SseService singleton)
  private eventSource2: EventSource | null = null;
  
  // Cache para parâmetros de stream (polling a cada 20 segundos)
  private cachedYoutubeUrl: string | null = null;
  private cachedVcuId: string | null = null;
  private cachedVcuId2: string | null = null; // Cache do segundo VCU
  private streamParametersPollingInterval: any = null;
  private readonly STREAM_POLLING_INTERVAL_MS = 20000; // 20 segundos
  
  // Timeout para zerar parâmetros após 5 minutos sem dados do SSE
  private lastSSEDataTimestamp: number = 0;
  private sseTimeoutCheckInterval: any = null;
  private readonly SSE_TIMEOUT_MS = 300000; // 5 minutos em milissegundos
  private readonly SSE_TIMEOUT_CHECK_INTERVAL_MS = 30000; // Verificar a cada 30 segundos
  isLoadingParameters: boolean = true;
  isMapMaximized: boolean = false;
  isVideoPip: boolean = false;
  private videoPipStateBeforeMaximize: boolean = false;
  private defaultZoom: number = 15;
  private currentCarPosition: L.LatLng | null = null;
  ProjectOptionData: ProjectOption | null = null;
  private _fuelpressure: number = 0;
  private _rpm: number = 0;
  private _latitude: number = 0;
  private _longitude: number = 0;
  private _temperature: number = 0;
  private _speed: number = 0;
  private _oilpressure: number = 0;
  private _tps: number = 0;
  private _gear: number = 0;
  private _sonda: number = 0;
  private shouldContinuePolling: boolean = true;
  private readonly VCU_STATUS_KEY = 'vcu_last_status';
  private readonly COORDINATES_HISTORY_CACHE_KEY = 'vcu_coordinates_history_cache';
  private readonly MAX_CACHED_COORDINATES = 3000; // Limite para evitar QuotaExceededError
  private vcuPollingSubscription: Subscription | null = null;
  private isAutoTrackingEnabled: boolean = true;
  
  private changeLocationMarker: boolean = false;
  private lastLocationLat: number = 0;
  private lastLocationLng: number = 0;
  
  // Controle de checkpoint com timer de 1 minuto
  private checkpointMarkers: L.Marker[] = []; // Array para múltiplos checkpoints
  private checkpointTimer: any = null; // Timer para aguardar 1 minuto
  private stationaryStartTime: number = 0; // Momento em que o veículo parou
  private readonly CHECKPOINT_DELAY_MS = 300000; // 5 minutos em milissegundos
  private lastLogTime: number = 0; // Controle para não poluir o console

  // Histórico de coordenadas (trajeto já percorrido)
  private historyPolyline!: L.Polyline; // Polyline para o trajeto histórico
  private historyLoaded: boolean = false; // Controle para evitar recarregar o histórico
  isLoadingHistory: boolean = false; // Loading state para UI



  // Dialog control
  showSelectProjectDialog: boolean = false;
  showConfirmationWithProjectDialog: boolean = false;
  showConfirmationWithoutProjectDialog: boolean = false;
  showCreateProjectDialog: boolean = false;
  showCardFullscreenModal: boolean = false;
  selectedProjectId: number | null = null;
  projectOptions: any[] = [];
  selectedProjectData: any = null;

  // Card download properties
  showCardDownloadDialog: boolean = false;
  qrCodeDataUrl: string = '';
  downloadingPDF: boolean = false;
  downloadingWord: boolean = false;
  loadingCardGeneration: boolean = false;
  previousModalState: boolean = false;

  dataPublicProject: PaginationPublicProjects | undefined;
  dataPublicLinkProject: GetAllPublicProjectsResponse | undefined;
  totalRecords: number = 0;
  selectedFavoriteProjectIDs: string[] = [];
  currentPage: number = 1;
  rowsPerPage: number = 15;

  products = signal<any>([]);

  constructor(
    private telemetryService: TelemetryService,
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private authService: AuthService,
    private publicService: PublicService,
    private messageService: MessageService,
    private router: Router,
    private accountService: AccountService,
    private translocoService: TranslocoService
  ) { }

  ngOnInit() {
    // Get route parameters
    this.route.params.subscribe(params => {
      this.carId = params['carId'] || '';
      this.eventName = params['eventName'] || 'Evento';
    });

    this.route.queryParams.subscribe(params => {
      this.projectName = params['projectName'] || '';
      this.userName = params['userName'] || '';
    });

    // Initialize project options (will be loaded from API)
    this.loadProjects();
    
    // Carregar lista de favoritos e depois carregar projetos confirmados
    this.getSelectedFavoriteProjectList(() => {
      this.loadConfirmedProjects();
    });
    
    // Restaurar último status do sessionStorage
    this.loadLastVCUStatus();
    
    // Buscar parâmetros de stream realtime
    this.loadStreamRealtimeParameters();
  }

  ngAfterViewInit() {
    this.initMap();
    // Nota: A conexão SSE será iniciada após o carregamento dos parâmetros em loadStreamRealtimeParameters()
    // O histórico de coordenadas também será carregado após os parâmetros
  }

  ngOnDestroy() {
    // Parar o polling recursivo PRIMEIRO
    this.shouldContinuePolling = false;
    
    // Parar polling de parâmetros de stream
    if (this.streamParametersPollingInterval) {
      clearInterval(this.streamParametersPollingInterval);
      this.streamParametersPollingInterval = null;
    }
    
    // Parar verificação de timeout do SSE
    if (this.sseTimeoutCheckInterval) {
      clearInterval(this.sseTimeoutCheckInterval);
      this.sseTimeoutCheckInterval = null;
    }
    
    // Fechar conexão SSE do segundo VCU
    if (this.eventSource2) {
      this.eventSource2.close();
      this.eventSource2 = null;
    }
    
    // Cancelar a subscription HTTP pendente do VCU
    if (this.vcuPollingSubscription) {
      this.vcuPollingSubscription.unsubscribe();
      this.vcuPollingSubscription = null;
    }
    
    // Salvar último status no sessionStorage
    this.saveLastVCUStatus();
    
    // Limpar timer de checkpoint pendente
    if (this.checkpointTimer) {
      clearTimeout(this.checkpointTimer);
      this.checkpointTimer = null;
    }
    
    this.subscription.unsubscribe();
    this.telemetryService.disconnect();
    
    if (this.map) {
      this.map.remove();
    }
  }

  private initMap(): void {
    // Verificar se há uma posição salva da VCU
    let initialLat: number;
    let initialLng: number;
    let initialZoom: number;

    if (this._latitude !== 0 && this._longitude !== 0) {
      // Se há posição da VCU salva, usar ela
      initialLat = this._latitude;
      initialLng = this._longitude;
      initialZoom = 15;
    } else {
      // Se não há posição da VCU, iniciar na FuelTech (Rua Bernardino Bernardi, Anchieta, Porto Alegre)
      initialLat = -29.987831809548776;
      initialLng = -51.16455712369671;
      initialZoom = 15;
    }

    this.map = L.map('map', {
      center: [initialLat, initialLng],
      zoom: initialZoom,
      zoomControl: true
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors',
      maxZoom: 19
    }).addTo(this.map);

    // Create custom icon using DivIcon for rotation support
    const customIcon = L.divIcon({
      html: `<div class="car-icon-wrapper">
               <div class="car-icon-rotate" style="transform: rotate(0deg); width: 40px; height: 40px;">
                 <img src="assets/img/ftvelopark/carrito.svg" style="width: 100%; height: 100%;">
               </div>
             </div>`,
      iconSize: [40, 40],
      iconAnchor: [20, 20], // Centro do ícone do carro
      popupAnchor: [0, -20],
      className: 'car-marker-icon'
    });

    // Add marker (posicionar o carro na localização inicial)
    this.marker = L.marker([initialLat, initialLng], {
      icon: customIcon,
      rotationOrigin: 'center center'
    } as any).addTo(this.map);
    
    // Adicionar tooltip com nome do carro (aparece no hover)
    this.marker.bindTooltip('Mustang Anderson Dick', {
      permanent: false,
      direction: 'bottom',
      offset: [0, 10],
      className: 'car-tooltip car-tooltip-1'
    });


    // Add destination marker (Autódromo Velopark)
    const destinationLat = -29.822199851850296;
    const destinationLng = -51.319872824836;
    
    const destinationIcon = L.icon({
      iconUrl: 'assets/img/ftvelopark/pinftvp.svg',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [80, 60],
      iconAnchor: [40, 30], // Centro do ícone para ficar fixo no zoom
      popupAnchor: [0, -30],
      shadowSize: [50, 50],
      shadowAnchor: [15, 25] // Alinha a sombra com o centro do ícone
    });
    
    this.destinationMarker = L.marker([destinationLat, destinationLng], {
      icon: destinationIcon
    }).addTo(this.map);
    
    this.destinationMarker.bindPopup('Autódromo FuelTech Velopark');

    // Add checkpoint marker
    // Dream Car Museum Sao Paulo
    const checkpointLat = -23.599403837139512;
    const checkpointLng = -47.15865947470719;
    
    const checkpointIcon = L.icon({
      iconUrl: 'assets/img/ftvelopark/mapicon.svg',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    
    this.checkpointMarker = L.marker([checkpointLat, checkpointLng], {
      icon: checkpointIcon
    }).addTo(this.map);
    
    // Popup estilizado para INÍCIO - Dream Car Museum
    const inicioPopupContent = `
      <div class="caravan-popup inicio-popup">
        <div class="popup-header">
          <span class="popup-flag">🏁</span>
          <span class="popup-title">INÍCIO</span>
        </div>
        <div class="popup-date">05/02 (QUINTA-FEIRA) ÀS 10H</div>
        <div class="popup-description">
          Concentração e saída oficial:<br>
          <strong>Dream Car Museum</strong><br>
          São Roque/SP
        </div>
      </div>
    `;
    this.checkpointMarker.bindPopup(inicioPopupContent, { className: 'caravan-popup-wrapper' });
    
    // Adicionar hover para mostrar popup
    this.checkpointMarker.on('mouseover', function(this: L.Marker) { this.openPopup(); });
    this.checkpointMarker.on('mouseout', function(this: L.Marker) { this.closePopup(); });

    // 1ª PARADA - Shopping Boulevard Curitiba
    const parada1Lat = -25.44226;
    const parada1Lng = -49.27692;
    
    const parada1Icon = L.icon({
      iconUrl: 'assets/img/ftvelopark/mapicon.svg',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    
    this.parada1Marker = L.marker([parada1Lat, parada1Lng], {
      icon: parada1Icon
    }).addTo(this.map);
    
    const parada1PopupContent = `
      <div class="caravan-popup parada1-popup">
        <div class="popup-header">
          <span class="popup-number">1ª</span>
          <span class="popup-title">PARADA</span>
        </div>
        <div class="popup-date">05/02 ÀS 18H</div>
        <div class="popup-description">
          Chegada:<br>
          <strong>Shopping Boulevard</strong><br>
          Curitiba/PR
        </div>
      </div>
    `;
    this.parada1Marker.bindPopup(parada1PopupContent, { className: 'caravan-popup-wrapper' });
    
    // Adicionar hover para mostrar popup
    this.parada1Marker.on('mouseover', function(this: L.Marker) { this.openPopup(); });
    this.parada1Marker.on('mouseout', function(this: L.Marker) { this.closePopup(); });

    // SAÍDA - Hotel Bristol Portal do Iguaçu
    const saidaLat = -25.42840;
    const saidaLng = -49.26680;
    
    const saidaIcon = L.icon({
      iconUrl: 'assets/img/ftvelopark/mapicon.svg',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    
    this.saidaMarker = L.marker([saidaLat, saidaLng], {
      icon: saidaIcon
    }).addTo(this.map);
    
    const saidaPopupContent = `
      <div class="caravan-popup saida-popup">
        <div class="popup-header">
          <span class="popup-flag"></span>
          <span class="popup-title">SAÍDA</span>
        </div>
        <div class="popup-date">06/02 (SEXTA-FEIRA) ÀS 6:30H</div>
        <div class="popup-description">
          Saída oficial (Curitiba):<br>
          <strong>Hotel Bristol Portal do Iguaçu</strong><br>
          Curitiba/PR
        </div>
      </div>
    `;
    this.saidaMarker.bindPopup(saidaPopupContent, { className: 'caravan-popup-wrapper' });
    
    // Adicionar hover para mostrar popup
    this.saidaMarker.on('mouseover', function(this: L.Marker) { this.openPopup(); });
    this.saidaMarker.on('mouseout', function(this: L.Marker) { this.closePopup(); });

    // 2ª PARADA - Speedway Balneário Camboriú
    const parada2Lat = -26.99060;
    const parada2Lng = -48.63520;
    
    const parada2Icon = L.icon({
      iconUrl: 'assets/img/ftvelopark/mapicon.svg',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    
    this.parada2Marker = L.marker([parada2Lat, parada2Lng], {
      icon: parada2Icon
    }).addTo(this.map);
    
    const parada2PopupContent = `
      <div class="caravan-popup parada2-popup">
        <div class="popup-header">
          <span class="popup-number">2ª</span>
          <span class="popup-title">PARADA</span>
        </div>
        <div class="popup-date">06/02 (SEXTA-FEIRA)</div>
        <div class="popup-subdate">Chegada estimada: 10h | Saída: 11h</div>
        <div class="popup-description">
          Ponto de encontro (SC):<br>
          <strong>Speedway</strong><br>
          Balneário Camboriú/SC
        </div>
      </div>
    `;
    this.parada2Marker.bindPopup(parada2PopupContent, { className: 'caravan-popup-wrapper' });
    
    // Adicionar hover para mostrar popup
    this.parada2Marker.on('mouseover', function(this: L.Marker) { this.openPopup(); });
    this.parada2Marker.on('mouseout', function(this: L.Marker) { this.closePopup(); });

    // Atualizar popup do destino (Velopark) com estilo
    const destinoPopupContent = `
      <div class="caravan-popup destino-popup">
        <div class="popup-header">
          <span class="popup-flag">🏆</span>
          <span class="popup-title">RECEPÇÃO OFICIAL DA CARAVANA</span>
        </div>
        <div class="popup-date">06/02 (SEXTA-FEIRA)</div>
        <div class="popup-description">
          Chegada estimada às 18h no<br>
          <strong>Autódromo FuelTech Velopark</strong><br>
          (Portão 2)<br>
          Nova Santa Rita/RS
        </div>
      </div>
    `;
    this.destinationMarker.bindPopup(destinoPopupContent, { className: 'caravan-popup-wrapper' });
    
    // Adicionar hover para mostrar popup
    this.destinationMarker.on('mouseover', function(this: L.Marker) { this.openPopup(); });
    this.destinationMarker.on('mouseout', function(this: L.Marker) { this.closePopup(); });

    // Criar a polyline para o trajeto histórico (já percorrido - carregado do banco)
    this.historyPolyline = L.polyline([], {
      color: '#AC281C', // Vermelho FuelTech
      weight: 4,
      opacity: 0.8,
      smoothFactor: 1,
      lineCap: 'round',
      lineJoin: 'round'
    }).addTo(this.map);

    // Criar a polyline para o traçado do caminho percorrido em tempo real
    this.pathPolyline = L.polyline([], {
      color: '#AC281C', // Vermelho FuelTech
      weight: 4,
      opacity: 0.8,
      smoothFactor: 1,
      lineCap: 'round',
      lineJoin: 'round'
    }).addTo(this.map);

    // Detectar quando o usuário arrasta o mapa para desabilitar auto-tracking
    this.map.on('dragstart', () => {
      this.isAutoTrackingEnabled = false;
    });

    // Fix map size after initialization
    setTimeout(() => {
      this.map.invalidateSize();
    }, 100);
  }

  /**
   * Carrega o histórico de coordenadas GPS da VCU e plota no mapa
   * Este método primeiro verifica o cache, plota os dados em cache,
   * e depois busca dados atualizados da API em background
   */
  private loadCoordinatesHistory(): void {
    if (this.historyLoaded) {
      //console.log('[RealtimeVCU] Histórico já carregado, ignorando...');
      return;
    }

    // Usar vcuId dinâmico carregado dos parâmetros
    const vcuId = this.dynamicVcuId || '0A11483028FT700 ASI';
    // Range de teste com dados existentes
    const startTime = '2026-02-05T00:00:00';
    const endTime = '2026-02-07T23:59:59';

    // Primeiro: Verificar se há dados em cache e plotar imediatamente
    const cachedData = this.loadCoordinatesFromCache();
    if (cachedData && cachedData.data && cachedData.data.length > 0) {
      this.plotHistoryPath(cachedData.data);
      this.historyLoaded = true;
    }

    // Segundo: Buscar dados atualizados da API em background
    this.isLoadingHistory = true;

    this.telemetryService.getVcuCoordinatesHistory(vcuId, startTime, endTime)
      .subscribe({
        next: (response: VcuCoordinatesHistoryResponse) => {
          
          if (response.data && response.data.length > 0) {
            // Salvar no cache para próximas visitas
            this.saveCoordinatesToCache(response);
            // Se ainda não plotou (não tinha cache), plotar agora
            if (!this.historyLoaded) {
              this.plotHistoryPath(response.data);
              this.historyLoaded = true;
            } else {
              // Se já tinha cache, atualizar apenas se houver mais dados
              const cachedCount = cachedData?.data?.length || 0;
              if (response.data.length > cachedCount) {
                this.plotHistoryPath(response.data);
              }
            }
          } else {
            //console.warn('[RealtimeVCU] Nenhuma coordenada no histórico');
          }
          
          this.isLoadingHistory = false;
        },
        error: (error) => {
          this.isLoadingHistory = false;
          // Se deu erro mas tinha cache, já plotou, então tudo bem
          if (!this.historyLoaded) {
            //console.error('[RealtimeVCU] Erro ao carregar histórico de coordenadas:', error);
          }
        }
      });
  }

  /**
   * Salva o histórico de coordenadas no cache (sessionStorage)
   * Implementa downsampling para evitar QuotaExceededError
   */
  private saveCoordinatesToCache(data: VcuCoordinatesHistoryResponse): void {
    try {
      // Limpar cache antigo antes de salvar
      sessionStorage.removeItem(this.COORDINATES_HISTORY_CACHE_KEY);
      
      // Aplicar downsampling se necessário
      let coordinatesToSave = data.data;
      if (data.data && data.data.length > this.MAX_CACHED_COORDINATES) {
        coordinatesToSave = this.downsampleCoordinates(data.data, this.MAX_CACHED_COORDINATES);
      }
      
      const cacheData = {
        timestamp: new Date().toISOString(),
        vcuId: data.vcuId,
        startTime: data.startTime,
        endTime: data.endTime,
        coordinatesCount: coordinatesToSave.length,
        originalCount: data.coordinatesCount,
        data: coordinatesToSave
      };
      
      sessionStorage.setItem(this.COORDINATES_HISTORY_CACHE_KEY, JSON.stringify(cacheData));
      //console.log(`[RealtimeVCU] Cache salvo: ${coordinatesToSave.length} coordenadas`);
    } catch (error) {
      // Se ainda der erro de quota, tentar com menos coordenadas
      if (error instanceof DOMException && error.name === 'QuotaExceededError') {
        this.saveReducedCache(data);
      } else {
        //console.error('[RealtimeVCU] Erro ao salvar cache de coordenadas:', error);
      }
    }
  }

  /**
   * Tenta salvar cache com quantidade reduzida de coordenadas
   */
  private saveReducedCache(data: VcuCoordinatesHistoryResponse): void {
    try {
      sessionStorage.removeItem(this.COORDINATES_HISTORY_CACHE_KEY);
      
      // Reduzir para 1000 coordenadas como fallback
      const reducedLimit = 1000;
      const coordinatesToSave = this.downsampleCoordinates(data.data, reducedLimit);
      
      const cacheData = {
        timestamp: new Date().toISOString(),
        vcuId: data.vcuId,
        startTime: data.startTime,
        endTime: data.endTime,
        coordinatesCount: coordinatesToSave.length,
        originalCount: data.coordinatesCount,
        data: coordinatesToSave
      };
      
      sessionStorage.setItem(this.COORDINATES_HISTORY_CACHE_KEY, JSON.stringify(cacheData));
    } catch (error) {
      //console.error('[RealtimeVCU] Erro ao salvar cache de coordenadas:', error);
    }
  }

  /**
   * Reduz o número de coordenadas mantendo a distribuição uniforme do trajeto
   * Mantém sempre a primeira e última coordenada para preservar início e fim do trajeto
   */
  private downsampleCoordinates(coordinates: any[], maxPoints: number): any[] {
    if (!coordinates || coordinates.length <= maxPoints) {
      return coordinates;
    }
    
    const result: any[] = [];
    const step = (coordinates.length - 1) / (maxPoints - 1);
    
    for (let i = 0; i < maxPoints - 1; i++) {
      const index = Math.round(i * step);
      result.push(coordinates[index]);
    }
    
    // Garantir que a última coordenada seja incluída
    result.push(coordinates[coordinates.length - 1]);
    
    return result;
  }

  /**
   * Carrega o histórico de coordenadas do cache (sessionStorage)
   */
  private loadCoordinatesFromCache(): VcuCoordinatesHistoryResponse | null {
    try {
      const cached = sessionStorage.getItem(this.COORDINATES_HISTORY_CACHE_KEY);
      if (cached) {
        const cacheData = JSON.parse(cached);
        return cacheData as VcuCoordinatesHistoryResponse;
      }
    } catch (error) {
      //console.error('[RealtimeVCU] Erro ao carregar cache de coordenadas:', error);
    }
    return null;
  }

  /**
   * Plota o trajeto histórico no mapa
   * Filtra coordenadas inválidas e converte para o formato correto
   * @param coordinates Array de coordenadas do histórico
   */
  private plotHistoryPath(coordinates: CoordinatePoint[]): void {
    if (!this.map || !this.historyPolyline) {
      //console.error('[RealtimeVCU] Mapa ou polyline não inicializados');
      return;
    }

    //console.log(`[RealtimeVCU] Processando ${coordinates.length} coordenadas do histórico...`);

    // Filtrar e converter coordenadas válidas
    const validCoordinates: L.LatLng[] = [];
    let invalidCount = 0;

    for (const coord of coordinates) {
      // Converter coordenadas do formato NMEA (DDMM.MMMM / DDDMM.MMMM) para graus decimais
      // O método convertToDecimalDegrees já detecta se já está em graus decimais
      let lat = this.convertToDecimalDegrees(coord.latitude, false);  // Latitude: 2 dígitos para graus
      let lng = this.convertToDecimalDegrees(coord.longitude, true);   // Longitude: 3 dígitos para graus

      // Validar se as coordenadas são válidas após conversão
      if (this.isValidCoordinate(lat, lng)) {
        validCoordinates.push(new L.LatLng(lat, lng));
      } else {
        invalidCount++;
      }
    }

    //console.log(`[RealtimeVCU] Coordenadas válidas: ${validCoordinates.length}, inválidas: ${invalidCount}`);

    if (validCoordinates.length > 0) {
      // Atualizar a polyline do histórico
      this.historyPolyline.setLatLngs(validCoordinates);

      // Só ajustar o mapa para mostrar todo o trajeto se NÃO houver posição salva da VCU
      // Isso garante que o mapa continue na última posição conhecida da VCU em tempo real
      if (this._latitude === 0 && this._longitude === 0) {
        const bounds = this.historyPolyline.getBounds();
        if (bounds.isValid()) {
          this.map.fitBounds(bounds, { padding: [50, 50] });
        }
      }
      // Adicionar as coordenadas ao pathCoordinates para continuar o traçado em tempo real
      // A última coordenada do histórico será o ponto de partida do tempo real
      if (validCoordinates.length > 0) {
        const lastHistoryCoord = validCoordinates[validCoordinates.length - 1];
        this.pathCoordinates = [lastHistoryCoord];
        this.pathPolyline.setLatLngs(this.pathCoordinates);
      }
    }
  }

  /**
   * Verifica se uma coordenada é válida
   * @param lat Latitude em graus decimais
   * @param lng Longitude em graus decimais
   * @returns true se a coordenada é válida
   */
  private isValidCoordinate(lat: number, lng: number): boolean {
    // Verificar se não é zero ou NaN
    if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
      return false;
    }
    // Verificar se está dentro dos limites válidos
    if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
      return false;
    }
    // Verificar se não é exatamente 0,0 (coordenada inválida comum)
    if (lat === 0 && lng === 0) {
      return false;
    }
    return true;
  }

  /**
   * Conecta ao SSE da VCU para receber dados em tempo real
   */
  private connectToVcuSSE(): void {
    // Usar vcuId dinâmico carregado dos parâmetros
    // Fallback para ID fixo caso não haja vcuId dinâmico
    const vcuId = this.dynamicVcuId || '0A11483028FT700 ASI';
    
    if (!this.dynamicVcuId) {
      //console.warn('[RealtimeVCU] Usando VCU ID padrão (fallback)');
    }
    
    //console.log('[RealtimeVCU] Conectando ao SSE com VCU ID:', vcuId);
    const vcuStreamSub = this.telemetryService.connectToVcuStream(vcuId)
      .subscribe({
        next: (data: any) => { 

          this.ProjectOptionData = data;
          this.hasTransmission = true;

          // Extrair values da nova estrutura: data.data.samples[0].values
          let values: { [key: string]: number } | null = null;

          // Nova estrutura: data.data.samples[0].values
          if (data?.data?.samples?.[0]?.values) {
            values = data.data.samples[0].values;
          }
          // Alternativa: data.samples[0].values
          else if (data?.samples?.[0]?.values) {
            values = data.samples[0].values;
          }

          if (values) {
            // Atualizar timestamp do último dado recebido
            this.lastSSEDataTimestamp = Date.now();

            // Mapear valores GlobalInfo_* para as variáveis da UI
            this._fuelpressure = values['GlobalInfo_Fuel_Pressure'] || 0;
            this._rpm = values['GlobalInfo_RPM'] || 0;
            this._temperature = values['GlobalInfo_Engine_Temperature'] || 0;
            this._speed = values['GlobalInfo_Speed'] || values['GlobalInfo_GPS_Speed_KPH'] || 0;
            this._sonda = values['GlobalInfo_O2'] || 0;
            this._oilpressure = values['GlobalInfo_Oil_Pressure'] || 0;
            this._tps = values['GlobalInfo_TPS'] || 0;
            this._gear = values['GlobalInfo_Gear_Actual'] || 0;

            // Coordenadas GPS
            const rawLatitude = values['GlobalInfo_GPS_Latitude'];
            const rawLongitude = values['GlobalInfo_GPS_Longitude'];

            if (rawLatitude && rawLongitude) {
              // Converter coordenadas de NMEA (DDMM.MMMM / DDDMM.MMMM) para graus decimais
              const newLatitude = this.convertToDecimalDegrees(rawLatitude, false);
              const newLongitude = this.convertToDecimalDegrees(rawLongitude, true);

              // Verificar se a localização mudou ou é zero
              this.checkForStationaryVehicle(newLatitude, newLongitude);

              // Atualizar as coordenadas do componente
              this._latitude = newLatitude;
              this._longitude = newLongitude;

              // Atualizar posição do mapa se as coordenadas forem válidas
              if (this._latitude !== 0 && this._longitude !== 0) {
                this.updateMapPosition(this._latitude, this._longitude);
              }
            }
          }
        },
        error: (error) => {
          //console.error('[RealtimeVCU] Error receiving VCU data:', error);
          this.isConnected = false;
        }
      });

    this.subscription.add(vcuStreamSub);

    // Também escuta o status da conexão
    const statusSub = this.telemetryService.getConnectionStatus()
      .subscribe(status => {
        this.isConnected = status.status === 'connected';
      });

    this.subscription.add(statusSub);
    
    // Iniciar verificação de timeout do SSE
    this.startSSETimeoutCheck();
  }

  /**
   * Inicia a verificação periódica de timeout do SSE
   * Se passar 5 minutos sem dados, zera os parâmetros de telemetria
   */
  private startSSETimeoutCheck(): void {
    // Limpar intervalo anterior se existir
    if (this.sseTimeoutCheckInterval) {
      clearInterval(this.sseTimeoutCheckInterval);
    }
    
    // Inicializar timestamp se ainda não foi definido
    if (this.lastSSEDataTimestamp === 0) {
      this.lastSSEDataTimestamp = Date.now();
    }
    
    this.sseTimeoutCheckInterval = setInterval(() => {
      this.checkSSETimeout();
    }, this.SSE_TIMEOUT_CHECK_INTERVAL_MS);
    
    //console.log('[RealtimeVCU] Verificação de timeout do SSE iniciada (intervalo: 30s, timeout: 5min)');
  }

  /**
   * Verifica se passou o tempo limite sem receber dados do SSE
   * Se sim, zera os parâmetros de telemetria (exceto latitude e longitude)
   */
  private checkSSETimeout(): void {
    const now = Date.now();
    const timeSinceLastData = now - this.lastSSEDataTimestamp;
    
    if (timeSinceLastData >= this.SSE_TIMEOUT_MS) {
      //console.warn(`[RealtimeVCU] Timeout do SSE! ${Math.floor(timeSinceLastData / 60000)} minutos sem dados. Zerando parâmetros...`);
      this.resetTelemetryParameters();
    }
  }

  /**
   * Zera os parâmetros de telemetria em tempo real
   * Mantém latitude e longitude inalterados
   */
  private resetTelemetryParameters(): void {
    //console.log('[RealtimeVCU] Zerando parâmetros de telemetria (mantendo lat/lng)');
    
    // Zerar parâmetros de telemetria
    this._fuelpressure = 0;
    this._rpm = 0;
    this._temperature = 0;
    this._speed = 0;
    this._oilpressure = 0;
    this._tps = 0;
    this._gear = 0;
    this._sonda = 0;
    
    // Latitude e longitude são mantidos
    // this._latitude = mantido
    // this._longitude = mantido
    
    //console.log('[RealtimeVCU] Parâmetros zerados. Lat:', this._latitude, 'Lng:', this._longitude);
  }

  /**
   * Método antigo de conexão via telemetria (mantido comentado para referência)
   */
  private connectToTelemetry(): void {
    if (!this.carId) return;

    const telemetrySub = this.telemetryService.connectToRealtime(this.carId)
      .subscribe({
        next: (data: TelemetryData) => {
          this.telemetryData = data;
          this.hasTransmission = true;
          this.isConnected = data.online || false;
          this.updateMapPosition(data.latitude, data.longitude);
        },
        error: (error) => {
          this.isConnected = false;
        }
      });

    this.subscription.add(telemetrySub);

    // Also listen to connection status
    const statusSub = this.telemetryService.getConnectionStatus()
      .subscribe(status => {
        this.isConnected = status.status === 'connected';
      });

    this.subscription.add(statusSub);
  }

  /**
   * Verifica se as coordenadas mudaram e atualiza o timer de checkpoint
   */
  private updateMapPosition(lat: number, lng: number): void {
    if (this.marker && this.map) {
      const newLatLng = new L.LatLng(lat, lng);
      
      // Calcular rotação do veículo baseado na direção do movimento
      if (this.previousCarPosition) {
        const distance = this.map.distance(this.previousCarPosition, newLatLng);
        
        // Só atualiza rotação se houver movimento significativo (mais de 5 metros)
        if (distance > 5) {
          const bearing = this.calculateBearing(this.previousCarPosition, newLatLng);
          this.updateMarkerRotation(bearing);
        } else {
          this.updateMarkerRotation(this.currentRotation);
        }
      } else {
        this.updateMarkerRotation(this.currentRotation);
      }
      
      // Atualizar posições
      this.previousCarPosition = this.currentCarPosition;
      this.currentCarPosition = newLatLng;
      this.marker.setLatLng(newLatLng);
      
      // Adicionar a nova posição ao traçado (evitando duplicatas muito próximas)
      if (this.pathCoordinates.length === 0) {
        this.pathCoordinates.push(newLatLng);
        this.pathPolyline.setLatLngs(this.pathCoordinates);
      } else {
        const lastPosition = this.pathCoordinates[this.pathCoordinates.length - 1];
        const distance = this.map.distance(lastPosition, newLatLng);
        
        if (distance > 10) {
          this.pathCoordinates.push(newLatLng);
          this.pathPolyline.setLatLngs(this.pathCoordinates);
        }
      }
      
      // Só recentraliza o mapa se o auto-tracking estiver ativo
      if (this.isAutoTrackingEnabled) {
        this.map.panTo(newLatLng);
      }
    }
  }

  get velocidade(): number {
    return this._speed || 0;
  }

  get rpm(): number {
    return this._rpm || 0;
  }

  get tps(): number {
    // TPS should be calculated from telemetry data if available
    return this._tps; // Placeholder
  }

  get marcha(): number {
    // Gear should be calculated from telemetry data if available
    return this._gear; // Placeholder
  }

  get temperaturaMotor(): number {
    return this._temperature || 0;
  }

  get sonda(): number {
    // Lambda sensor value should come from telemetry data
    return this._sonda; // Placeholder
  }

  get oilpressure(): number {
    // Lambda sensor value should come from telemetry data
    return this._oilpressure; // Placeholder
  }

  get fuelpressure(): number {
    // Lambda sensor value should come from telemetry data
    return this._fuelpressure;
  }

  toggleMapMaximize(): void {
    this.isMapMaximized = !this.isMapMaximized;
    const mapContainer = document.querySelector('.map-container');
    
    if (this.isMapMaximized) {
      // Salva o estado atual do vídeo antes de maximizar
      this.videoPipStateBeforeMaximize = this.isVideoPip;
      // Força o vídeo para modo PIP quando maximiza o mapa
      this.isVideoPip = true;
      mapContainer?.classList.add('maximized');
    } else {
      // Restaura o estado anterior do vídeo quando minimiza o mapa
      this.isVideoPip = this.videoPipStateBeforeMaximize;
      mapContainer?.classList.remove('maximized');
    }

    // Fix map size after maximizing/minimizing
    setTimeout(() => {
      this.map?.invalidateSize();
    }, 350);
  }

  toggleVideoPip(): void {
    // Se o mapa estiver maximizado, não permite desativar o PIP
    if (this.isMapMaximized && this.isVideoPip) {
      return;
    }
    
    this.isVideoPip = !this.isVideoPip;
    
    // Fix map size after toggling video PIP
    setTimeout(() => {
      this.map?.invalidateSize();
    }, 350);
  }

  resetMapZoom(): void {
    if (this.map) {
      this.map.setZoom(this.defaultZoom);
    }
  }

  centerMapOnCar(): void {
    // Alterna o estado do auto-tracking
    this.isAutoTrackingEnabled = !this.isAutoTrackingEnabled;
    
    // Se ativou o auto-tracking, centraliza imediatamente
    if (this.isAutoTrackingEnabled) {
      if (this.map && this.currentCarPosition) {
        this.map.panTo(this.currentCarPosition);
      } else if (this.map && this.marker) {
        const markerLatLng = this.marker.getLatLng();
        this.map.panTo(markerLatLng);
      }
    }
  }

  get autoTrackingEnabled(): boolean {
    return this.isAutoTrackingEnabled;
  }

  clearPath(): void {
    // Limpa o array de coordenadas
    this.pathCoordinates = [];
    
    // Atualiza a polyline para ficar vazia
    if (this.pathPolyline) {
      this.pathPolyline.setLatLngs([]);
    }
  }


  /**
   * Verifica se o veículo está parado na mesma posição
   * e inicia/cancela o timer de checkpoint de 1 minuto
   */
  private checkForStationaryVehicle(newLat: number, newLng: number): void {
    const GPS_TOLERANCE = 0.00001; // ~1 metro de tolerância
    
    // Se é a primeira leitura, apenas inicializa
    if (this.lastLocationLat === 0 && this.lastLocationLng === 0) {
      this.lastLocationLat = newLat;
      this.lastLocationLng = newLng;
      return;
    }

    // Calcular diferença entre coordenadas
    const latDiff = Math.abs(newLat - this.lastLocationLat);
    const lngDiff = Math.abs(newLng - this.lastLocationLng);
    
    // Verificar se está na mesma posição ou recebendo zero
    const isSamePosition = (latDiff < GPS_TOLERANCE && lngDiff < GPS_TOLERANCE);
    const isZeroPosition = (newLat === 0 && newLng === 0);
    const isStationary = isSamePosition || isZeroPosition;

    if (isStationary) {
      // Veículo está parado ou perdeu sinal
      if (this.checkpointTimer === null) {
        // Inicia o timer de 1 minuto
        this.stationaryStartTime = Date.now();
        this.lastLogTime = Date.now();
        const positionToMark = isZeroPosition 
          ? { lat: this.lastLocationLat, lng: this.lastLocationLng }
          : { lat: newLat, lng: newLng };
        
        this.checkpointTimer = setTimeout(() => {
          this.markCheckpoint(positionToMark.lat, positionToMark.lng);
          this.checkpointTimer = null;
        }, this.CHECKPOINT_DELAY_MS);
      } else {
        // Timer já está rodando - log apenas a cada 10 segundos
        const now = Date.now();
        const elapsed = Math.floor((now - this.stationaryStartTime) / 1000);
        const timeSinceLastLog = Math.floor((now - this.lastLogTime) / 1000);
        
        // Mostrar log apenas a cada 10 segundos
        if (timeSinceLastLog >= 10) {
          this.lastLogTime = now;
        }
      }
    } else {
      // Veículo se moveu - cancelar timer se existir
      if (this.checkpointTimer !== null) {
        clearTimeout(this.checkpointTimer);
        this.checkpointTimer = null;
        const elapsed = Math.floor((Date.now() - this.stationaryStartTime) / 1000);
      }
      
      // Atualizar última posição
      this.lastLocationLat = newLat;
      this.lastLocationLng = newLng;
    }
  }

  /**
   * Marca um checkpoint no mapa na localização especificada
   */
  private markCheckpoint(lat: number, lng: number): void {
    if (!this.map) {
      return;
    }

    // Verificar se já existe checkpoint muito próximo (evitar duplicatas)
    const existingCheckpoint = this.checkpointMarkers.find(marker => {
      const markerLatLng = marker.getLatLng();
      const distLat = Math.abs(markerLatLng.lat - lat);
      const distLng = Math.abs(markerLatLng.lng - lng);
      return distLat < 0.0001 && distLng < 0.0001;
    });

    if (existingCheckpoint) {
      return;
    }

    // Criar ícone para o checkpoint
    const checkpointIcon = L.icon({
      iconUrl: 'assets/img/ftvelopark/mapicon.svg',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    
    // Criar novo marcador
    const timestamp = new Date().toLocaleString('pt-BR');
    const checkpointNumber = this.checkpointMarkers.length + 1;
    
    const newCheckpointMarker = L.marker([lat, lng], {
      icon: checkpointIcon
    }).addTo(this.map);
    
    newCheckpointMarker.bindPopup(`Checkpoint #${checkpointNumber}<br>${timestamp}<br>Parado por 1 minuto`);
    
    // Adicionar ao array
    this.checkpointMarkers.push(newCheckpointMarker);
    
    // Abrir popup temporariamente
    newCheckpointMarker.openPopup();
    setTimeout(() => {
      newCheckpointMarker.closePopup();
    }, 5000);

  }

  /**
   * Calcula o bearing (azimute) entre duas coordenadas em graus
   * @param from Coordenada de origem
   * @param to Coordenada de destino
   * @returns Ângulo em graus (0-360)
   */
  private calculateBearing(from: L.LatLng, to: L.LatLng): number {
    const lat1 = from.lat * Math.PI / 180;
    const lat2 = to.lat * Math.PI / 180;
    const dLon = (to.lng - from.lng) * Math.PI / 180;

    const y = Math.sin(dLon) * Math.cos(lat2);
    const x = Math.cos(lat1) * Math.sin(lat2) -
              Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
    
    let bearing = Math.atan2(y, x) * 180 / Math.PI;
    
    // Normalizar para 0-360 e adicionar 180° para corrigir orientação do SVG
    bearing = (bearing + 180 + 360) % 360;
    
    return bearing;
  }

  /**
   * Atualiza a rotação visual do marcador do carro
   * @param angle Ângulo em graus
   */
  private updateMarkerRotation(angle: number): void {
    if (this.marker) {
      // Salvar a rotação atual
      this.currentRotation = angle;
      
      const newIcon = L.divIcon({
        html: `<div class="car-icon-wrapper">
                 <div class="car-icon-rotate" style="transform: rotate(${angle}deg); width: 40px; height: 40px; transition: transform 0.3s ease;">
                   <img src="assets/img/ftvelopark/carrito.svg" style="width: 100%; height: 100%;">
                 </div>
               </div>`,
        iconSize: [40, 40],
        iconAnchor: [20, 20], // Centro do ícone do carro
        popupAnchor: [0, -20],
        className: 'car-marker-icon'
      });
      
      this.marker.setIcon(newIcon);
    }
  }


  // Dialog methods
  loadProjects(): void {
    //console.log('Loading projects for user');
    const userId = this.authService.getUserInformations()
    
    if (!userId) {
      this.projectOptions = [
        { id: 0, name: 'Irei ao evento, mas sem um projeto' }
      ];
      return;
    }

    this.projectService.findAllProjectSummary(userId, "AC", "AC,AP").subscribe({
      next: (projects) => {
        //console.log('Raw projects from service:', projects);
        
        this.projectOptions = [
          { id: '00000000-0000-0000-0000-000000000000', name: 'Irei ao evento, mas sem um projeto' }
        ];
        
        if (projects && projects.length > 0) {
          const userProjects = projects.map(project => ({
            id: project.projectID,
            name: project.projectName
          }));
          this.projectOptions = [...this.projectOptions, ...userProjects];
          //console.log('Mapped projects:', userProjects);
        }
        //console.log('Final project options:', this.projectOptions);
      },
      error: (error) => {
        //console.error('Erro ao carregar projetos:', error);
        this.projectOptions = [
          { id: 0, name: 'Irei ao evento, mas sem um projeto' }
        ];
      }
    });
  }

  loadConfirmedProjects(): void {
    this.publicService
      .getAllPublicProjects(sharingProjectType.PUBLIC, null)
      .subscribe({
        next: (data) => {
          const convertProjects = (data.listItens ?? []).map((item: any) =>
            this.toProjectSummary(item)
          );
          this.products.set(convertProjects);
        },
        error: () => {
          this.products.set([]);
          this.messageService.add({
            key: "toastAccount",
            severity: "error",
            summary: this.translocoService.translate('messages.error.loadProjectsError'),
          });
        },
      });
  }

  onPageChange(event: any): void {
    const currentPage = Math.floor(event.first / event.rows) + 1;
    this.currentPage = currentPage;
    this.rowsPerPage = event.rows;
    
    // Recarrega os projetos com a nova página
    this.loadConfirmedProjects();
  }

  openConfirmationDialog(): void {
    this.showSelectProjectDialog = true;
    document.body.style.overflow = 'hidden';
    this.loadProjects();
  }

  closeSelectProjectDialog(): void {
    this.showSelectProjectDialog = false;
    this.selectedProjectId = null;
    // Restaurar scroll apenas se não houver outro modal aberto
    if (!this.showConfirmationWithProjectDialog && !this.showConfirmationWithoutProjectDialog && !this.showCardDownloadDialog) {
      document.body.style.overflow = 'auto';
    }
  }

  confirmPresence(): void {
    if (this.selectedProjectId === null) {
      return;
    }
    
    const userId = this.authService.getUserInformations();
    this.projectService.confirmParticipation(userId!, this.selectedProjectId.toString()).subscribe({
      next: (response) => {        
        // Verifica o código de retorno do backend
        if (response.returnCode === 'AC002') {
          // Presença já confirmada anteriormente - mantém no modal atual e exibe mensagem
          this.messageService.add({
            key: "toastMessage",
            severity: 'success',
            summary: this.translocoService.translate('messages.success.presenceAlreadyConfirmed'),
            detail: this.translocoService.translate('messages.success.presenceAlreadyConfirmedDesc'),
            life: 5000
          });

          this.showConfirmationWithProjectDialog = true;
          document.body.style.overflow = 'hidden';

        } else if (response.returnCode === 'AC005' || response.returnCode === 'AC001') {
          this.showSelectProjectDialog = false;
          
          this.loadConfirmedProjects();
          
          this.messageService.add({
            key: "toastMessage",
            severity: 'success',
            summary: this.translocoService.translate('messages.success.presenceConfirmed'),
            detail: this.translocoService.translate('messages.success.presenceConfirmedDesc'),
            life: 5000
          });
          
          if (this.selectedProjectId?.toString() === '00000000-0000-0000-0000-000000000000') {
            this.showConfirmationWithoutProjectDialog = true;
            document.body.style.overflow = 'hidden';
          } else {
            this.showConfirmationWithProjectDialog = true;
            document.body.style.overflow = 'hidden';
          }
          this.loadConfirmedProjects();
          
        } else if (response.returnCode === 'AC003') {
          this.messageService.add({
            key: "toastMessage",
            severity: 'error',
            summary: this.translocoService.translate('messages.error.confirmPresenceError'),
            detail: this.translocoService.translate('messages.error.projectNotFound'),
            life: 5000
          });
        } else if (response.returnCode === 'AC004') {
          this.messageService.add({
            key: "toastMessage",
            severity: 'error',
            summary: this.translocoService.translate('messages.error.confirmPresenceError'),
            detail: this.translocoService.translate('messages.error.confirmPresenceErrorDesc'),
            life: 5000
          });
        } else {
          this.messageService.add({
            key: "toastMessage",
            severity: 'warn',
            summary: this.translocoService.translate('messages.error.confirmPresenceWarning'),
            detail: this.translocoService.translate('messages.error.confirmPresenceWarningDesc'),
            life: 5000
          });
        }
      },
      error: (error) => {
        //console.error('Error confirming participation:', error);
        this.messageService.add({
          key: "toastMessage",
          severity: 'error',
          summary: this.translocoService.translate('messages.error.communicationError'),
          detail: this.translocoService.translate('messages.error.communicationErrorDesc'),
          life: 5000
        });
      }
    });
  }

  closeConfirmationWithProjectDialog(): void {
    this.closeAllDialogs();
  }

  closeConfirmationWithoutProjectDialog(): void {
    this.closeAllDialogs();
  }

  closeAllDialogs(): void {
    this.showSelectProjectDialog = false;
    this.showConfirmationWithProjectDialog = false;
    this.showConfirmationWithoutProjectDialog = false;
    this.showCreateProjectDialog = false;
    this.showCardFullscreenModal = false;
    this.showCardDownloadDialog = false;
    this.selectedProjectId = null;
    document.body.style.overflow = 'auto';
  }

  openCreateProjectDialog(): void {
    this.showSelectProjectDialog = false;
    this.showCreateProjectDialog = false;
    setTimeout(() => {
      this.showCreateProjectDialog = true;
      document.body.style.overflow = 'hidden';
    }, 0);
  }

  closeCreateProjectDialog(projectID?: any): void {
    this.showCreateProjectDialog = false;
    
    if (projectID && projectID !== '') {
      this.loadProjects();
      
      setTimeout(() => {
        const newProject = this.projectOptions.find(p => p.id === projectID);
        if (newProject) {
          this.selectedProjectId = newProject.id;
        }
        this.showSelectProjectDialog = true;
        document.body.style.overflow = 'hidden';
      }, 500);
    } else {
      this.showSelectProjectDialog = true;
      document.body.style.overflow = 'hidden';
    }
  }

  buyTicket(): void {
    window.open('https://eleventickets.com/fueltech-motorsports/inaugurao-autodromo-fueltech-velopark', '_blank');
  }

  async downloadCard(): Promise<void> {
    if (!this.selectedProjectId || this.selectedProjectId === 0) {
      this.messageService.add({
        key: "toastMessage",
        severity: 'warn',
        summary: this.translocoService.translate('common.labels.warning'),
        detail: this.translocoService.translate('messages.error.noProjectSelected')
      });
      return;
    }

    try {
      this.loadingCardGeneration = true;

      const userId = this.authService.getUserInformations();
      if (!userId) {
        this.loadingCardGeneration = false;
        return;
      }

      const selectedProject = this.projectOptions.find(p => p.id === this.selectedProjectId);
      if (!selectedProject) {
        this.loadingCardGeneration = false;
        this.messageService.add({
          key: "toastMessage",
          severity: 'error',
          summary: this.translocoService.translate('common.labels.error'),
          detail: this.translocoService.translate('messages.error.projectNotFoundCard')
        });
        return;
      }

      this.selectedProjectData = {
        name: selectedProject.name || 'NOME DO PROJETO',
        userName: this.userName || 'NOME USUÁRIO'
      };

      this.accountService.getAccount(userId).subscribe({
        next: async (accountData: AccountResponse) => {
          const userNickname = accountData.nickname;

          try {
            const publicUrl = `${window.location.origin}/project/public/${userNickname}/${this.selectedProjectId}`;
            
            this.qrCodeDataUrl = await QRCode.toDataURL(publicUrl, {
              width: 300,
              margin: 2,
              color: {
                dark: '#000000',
                light: '#FFFFFF'
              }
            });

            this.loadingCardGeneration = false;

            this.previousModalState = this.showConfirmationWithProjectDialog;
            this.showConfirmationWithProjectDialog = false;

            this.showCardDownloadDialog = true;
            document.body.style.overflow = 'hidden';
          } catch (error) {
            //console.error('Erro ao gerar QR Code:', error);
            this.loadingCardGeneration = false;
            this.messageService.add({
              key: "toastMessage",
              severity: 'error',
              summary: this.translocoService.translate('common.labels.error'),
              detail: this.translocoService.translate('messages.error.qrCodeError')
            });
          }
        },
        error: (error: any) => {
          //console.error('Error loading account data:', error);
          this.loadingCardGeneration = false;
          this.messageService.add({
            key: "toastMessage",
            severity: 'error',
            summary: this.translocoService.translate('common.labels.error'),
            detail: this.translocoService.translate('messages.error.accountDataError')
          });
        }
      });
    } catch (error) {
      //console.error('Erro ao processar download do card:', error);
      this.loadingCardGeneration = false;
      this.messageService.add({
        key: "toastMessage",
        severity: 'error',
        summary: this.translocoService.translate('common.labels.error'),
        detail: this.translocoService.translate('messages.error.cardProcessError')
      });
    }
  }
  
  closeCardFullscreenModal(): void {
    this.showCardFullscreenModal = false;
    
    document.body.style.overflow = 'auto';
  }
  
  onCardModalKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.closeCardFullscreenModal();
    }
  }
  
  downloadCardImage(): void {
    // TODO: Implementar download da imagem do card
    //console.log('Download card image');
  }
  
  viewProjectFromCard(): void {
    if (this.selectedProjectId && this.selectedProjectId !== 0) {
      const userId = this.authService.getUserInformations();
      const projectName = this.selectedProjectData?.name || '';
      
      this.closeCardFullscreenModal();
      
      this.router.navigate(['/project', userId, this.selectedProjectId, projectName]);
    }
  }

  shareOnSocial(platform: string): void {
    // TODO: Share on social media
    //console.log('Share on:', platform);
  }

  closeCardDownloadDialog(): void {
    this.showCardDownloadDialog = false;
    
    if (this.previousModalState) {
      this.showConfirmationWithProjectDialog = true;
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }

  async downloadCardAsPDF(): Promise<void> {
    this.downloadingPDF = true;
    
    try {
      const cardElement = document.getElementById('print-card-content');
      if (!cardElement) {
        throw new Error('Elemento do card não encontrado');
      }

      const canvas = await html2canvas(cardElement, {
        scale: 3,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false
      });

      // Criar PDF
      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgData = canvas.toDataURL('image/png');
      const xOffset = 0;
      const yOffset = (297 - imgHeight) / 2; // Centralizar verticalmente em A4
      
      pdf.addImage(imgData, 'PNG', xOffset, yOffset, imgWidth, imgHeight);
      
      const fileName = `card-${this.selectedProjectData?.name || 'projeto'}.pdf`;
      pdf.save(fileName);

      this.messageService.add({
        key: "toastMessage",
        severity: 'success',
        summary: this.translocoService.translate('common.labels.success'),
        detail: this.translocoService.translate('messages.success.cardDownloaded')
      });
    } catch (error) {
      //console.error('Erro ao gerar PDF:', error);
      this.messageService.add({
        key: "toastMessage",
        severity: 'error',
        summary: this.translocoService.translate('common.labels.error'),
        detail: this.translocoService.translate('messages.error.pdfGenerateError')
      });
    } finally {
      this.downloadingPDF = false;
    }
  }

  async downloadCardAsWord(): Promise<void> {
    this.downloadingWord = true;
    
    try {
      if (!this.qrCodeDataUrl) {
        throw new Error('QR Code não gerado');
      }

      const qrCodeBase64 = this.qrCodeDataUrl.split(',')[1];
      const qrCodeBuffer = this.base64ToArrayBuffer(qrCodeBase64);

      const doc = new Document({
        sections: [{
          properties: {},
          children: [
            new Paragraph({
              alignment: AlignmentType.CENTER,
              children: [
                new TextRun({
                  text: 'SAIBA MAIS SOBRE ESTE',
                  bold: true,
                  size: 32,
                  font: 'Arial'
                })
              ],
              spacing: { after: 100 }
            }),
            new Paragraph({
              alignment: AlignmentType.CENTER,
              children: [
                new TextRun({
                  text: 'PROJETO NO FT PILOT!',
                  bold: true,
                  size: 32,
                  font: 'Arial'
                })
              ],
              spacing: { after: 200 }
            }),
            new Paragraph({
              alignment: AlignmentType.CENTER,
              children: [
                new TextRun({
                  text: 'Escaneie o QR Code para visualizar o',
                  size: 20,
                  font: 'Arial'
                })
              ],
              spacing: { after: 50 }
            }),
            new Paragraph({
              alignment: AlignmentType.CENTER,
              children: [
                new TextRun({
                  text: 'projeto completo.',
                  size: 20,
                  font: 'Arial'
                })
              ],
              spacing: { after: 300 }
            }),
            new Paragraph({
              alignment: AlignmentType.CENTER,
              children: [
                new ImageRun({
                  data: qrCodeBuffer,
                  transformation: {
                    width: 250,
                    height: 250
                  },
                  type: 'png'
                } as any)
              ],
              spacing: { after: 400 }
            }),
            new Paragraph({
              alignment: AlignmentType.CENTER,
              children: [
                new TextRun({
                  text: 'FT PILOT',
                  bold: true,
                  size: 28,
                  color: 'E31F12',
                  font: 'Arial'
                })
              ]
            })
          ]
        }]
      });

      const blob = await Packer.toBlob(doc);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `card-${this.selectedProjectData?.name || 'projeto'}.docx`;
      link.click();
      window.URL.revokeObjectURL(url);

      this.messageService.add({
        key: "toastMessage",
        severity: 'success',
        summary: this.translocoService.translate('common.labels.success'),
        detail: this.translocoService.translate('messages.success.cardDownloadedWord')
      });
    } catch (error) {
      //console.error('Erro ao gerar Word:', error);
      this.messageService.add({
        key: "toastMessage",
        severity: 'error',
        summary: this.translocoService.translate('common.labels.error'),
        detail: this.translocoService.translate('messages.error.wordGenerateError')
      });
    } finally {
      this.downloadingWord = false;
    }
  }

  private base64ToArrayBuffer(base64: string): Uint8Array {
    const binaryString = window.atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  /**
   * Converte coordenadas GPS do formato NMEA para graus decimais
   * Latitude: DDMM.MMMM (2 dígitos para graus)
   * Longitude: DDDMM.MMMM (3 dígitos para graus)
   * @param coordinate Coordenada em formato NMEA
   * @param isLongitude true se for longitude (usa 3 dígitos para graus)
   * @returns Coordenada em graus decimais
   */
  private convertToDecimalDegrees(coordinate: number, isLongitude: boolean = false): number {
    if (!coordinate || coordinate === 0) {
      return 0;
    }

    const absCoordinate = Math.abs(coordinate);
    
    // Verificar se já está em graus decimais (valores menores que o esperado para NMEA)
    // Latitude em NMEA: mínimo ~100 (01°00.0000'), máximo ~9000 (90°00.0000')
    // Longitude em NMEA: mínimo ~100 (001°00.0000'), máximo ~18000 (180°00.0000')
    // Se o valor absoluto for menor que 90 (lat) ou 180 (lng), provavelmente já está em graus decimais
    const maxDecimalDegrees = isLongitude ? 180 : 90;
    if (absCoordinate <= maxDecimalDegrees) {
      // Já está em graus decimais, retornar como está
      return coordinate;
    }

    // Número de dígitos para graus: 2 para latitude, 3 para longitude
    const degreesDigits = isLongitude ? 3 : 2;
    
    // Usar divisão matemática em vez de string para mais precisão
    // DDMM.MMMM ou DDDMM.MMMM
    const divisor = isLongitude ? 100 : 100; // Para extrair graus
    const degrees = Math.floor(absCoordinate / 100);
    const minutes = absCoordinate - (degrees * 100);
    
    // Validar que os minutos estão no range correto (0-59.9999)
    if (minutes >= 60) {
      //console.warn(`[convertToDecimalDegrees] Minutos inválidos: ${minutes} para coordenada ${coordinate}`);
      // Tentar interpretar como já convertido ou retornar 0
      return 0;
    }
    
    const decimalDegrees = degrees + (minutes / 60);
    
    // Manter o sinal original (negativo para sul/oeste)
    return coordinate < 0 ? -decimalDegrees : decimalDegrees;
  }

  /**
   * Salva o último status da VCU no sessionStorage
   */
  private saveLastVCUStatus(): void {
    if (this.ProjectOptionData) {
      const status = {
        fuelpressure: this._fuelpressure,
        rpm: this._rpm,
        temperature: this._temperature,
        speed: this._speed,
        o2: this._sonda,
        oilpressure: this._oilpressure,
        tps: this._tps,
        gear: this._gear,
        latitude: this._latitude,
        longitude: this._longitude,
        lastLocationLat: this.lastLocationLat,
        lastLocationLng: this.lastLocationLng,
        timestamp: new Date().toISOString(),
        lastData: this.ProjectOptionData
      };
      sessionStorage.setItem(this.VCU_STATUS_KEY, JSON.stringify(status));
      //console.log('VCU status saved to sessionStorage');
    }
  }

  /**
   * Carrega o último status da VCU do sessionStorage
   */
  private loadLastVCUStatus(): void {
    const savedStatus = sessionStorage.getItem(this.VCU_STATUS_KEY);
    if (savedStatus) {
      try {
        const status = JSON.parse(savedStatus);
        this._fuelpressure = status.fuelpressure || 0;
        this._rpm = status.rpm || 0;
        this._temperature = status.temperature || 0;
        this._speed = status.speed || 0;
        this._sonda = status.o2 || 0;
        this._oilpressure = status.oilpressure || 0;
        this._tps = status.tps || 0;
        this._gear = status.gear || 0;
        this._latitude = status.latitude || 0;
        this._longitude = status.longitude || 0;
        this.ProjectOptionData = status.lastData || null;

        this.lastLocationLat = status.lastLocationLat || status.latitude || 0;
        this.lastLocationLng = status.lastLocationLng || status.longitude || 0;
      } catch (error) {
        //console.error('[RealtimeVCU] Error loading VCU status from sessionStorage:', error);
      }
    }
  }

  /**
   * Carrega os parâmetros de stream realtime do endpoint parameter_tasks
   * Extrai o link do YouTube e o vcuId de channels
   * Inicia o polling a cada 20 segundos para verificar mudanças
   */
  private loadStreamRealtimeParameters(): void {
    this.isLoadingParameters = true;
    
    const userId = this.authService.getUserInformations();
    const language = 'pt-br'; // ou obter do serviço de idioma
    
    if (!userId) {
      //console.warn('[RealtimeVCU] Usuário não logado, usando valores padrão');
      this.isLoadingParameters = false;
      this.hasVideoStream = false;
      this.hasMapStream = false;
      return;
    }

    // Fazer a primeira chamada
    this.fetchAndProcessStreamParameters(userId, language, true);
    
    // Iniciar polling a cada 20 segundos
    this.startStreamParametersPolling(userId, language);
  }

  /**
   * Inicia o polling de parâmetros de stream a cada 20 segundos
   */
  private startStreamParametersPolling(userId: string, language: string): void {
    // Limpar intervalo anterior se existir
    if (this.streamParametersPollingInterval) {
      clearInterval(this.streamParametersPollingInterval);
    }
    
    this.streamParametersPollingInterval = setInterval(() => {
      //console.log('[RealtimeVCU] Polling de parâmetros de stream...');
      this.fetchAndProcessStreamParameters(userId, language, false);
    }, this.STREAM_POLLING_INTERVAL_MS);
  }

  /**
   * Busca e processa os parâmetros de stream
   * @param userId ID do usuário
   * @param language Idioma
   * @param isInitialLoad Se é a primeira carga (inicializa conexões)
   */
  private fetchAndProcessStreamParameters(userId: string, language: string, isInitialLoad: boolean): void {
    this.telemetryService.getStreamRealtimeParameters(userId, language)
      .subscribe({
        next: (parameters: StreamRealtimeParameter[]) => {
          //console.log('[RealtimeVCU] Parâmetros de stream recebidos:', parameters);
          
          // Buscar o parâmetro stream-realtime
          const streamRealtimeParam = parameters.find(p => p.analysesName === 'stream-realtime');
          
          if (streamRealtimeParam && streamRealtimeParam.presets && streamRealtimeParam.presets.length > 0) {
            const streamPreset = streamRealtimeParam.presets.find(p => p.name === 'stream');
            
            if (streamPreset && streamPreset.value && streamPreset.value.channels) {
              const channels = streamPreset.value.channels;
              
              // Extrair valores dos canais
              // channels[0] = YouTube URL
              // channels[1] = VCU ID 1
              // channels[2] = VCU ID 2 (opcional)
              const newYoutubeUrl = channels[0];
              const newVcuId = channels[1];
              const newVcuId2 = channels.length > 2 ? channels[2] : null;
              
              //console.log('[RealtimeVCU] Channels recebidos:', { youtube: newYoutubeUrl, vcu1: newVcuId, vcu2: newVcuId2 });
              
              // Processar YouTube URL
              this.processYoutubeUrlChange(newYoutubeUrl, isInitialLoad);
              
              // Processar VCU ID 1
              this.processVcuIdChange(newVcuId, isInitialLoad);
              
              // Processar VCU ID 2 (se existir)
              this.processVcuId2Change(newVcuId2, isInitialLoad);
            }
          } else {
            //console.warn('[RealtimeVCU] Parâmetro stream-realtime não encontrado');
            if (isInitialLoad) {
              this.hasVideoStream = false;
              this.hasMapStream = false;
              this.hasTransmission = false;
            }
          }
          
          this.isLoadingParameters = false;
        },
        error: (error) => {
          //console.error('[RealtimeVCU] Erro ao carregar parâmetros de stream:', error);
          if (isInitialLoad) {
            this.isLoadingParameters = false;
            this.hasVideoStream = false;
            this.hasMapStream = false;
            this.hasTransmission = false;
          }
        }
      });
  }

  /**
   * Processa mudança no YouTube URL comparando com cache
   */
  private processYoutubeUrlChange(newYoutubeUrl: string | null, isInitialLoad: boolean): void {
    const isValidUrl = newYoutubeUrl && newYoutubeUrl !== 'null' && newYoutubeUrl.trim() !== '';
    const normalizedNewUrl = isValidUrl ? newYoutubeUrl : null;
    
    // Verificar se houve mudança comparando com o cache
    if (normalizedNewUrl !== this.cachedYoutubeUrl) {
      //console.log('[RealtimeVCU] YouTube URL alterado:', {
      //  antigo: this.cachedYoutubeUrl,
      //  novo: normalizedNewUrl
      //});
      
      // Atualizar cache
      this.cachedYoutubeUrl = normalizedNewUrl;
      
      // Atualizar estado
      if (isValidUrl) {
        this.youtubeStreamUrl = this.convertToEmbedUrl(newYoutubeUrl!);
        this.hasVideoStream = true;
        //console.log('[RealtimeVCU] YouTube URL atualizado:', this.youtubeStreamUrl);
      } else {
        this.youtubeStreamUrl = null;
        this.hasVideoStream = false;
        //console.log('[RealtimeVCU] YouTube URL é null, mostrando placeholder');
      }
    } else if (!isInitialLoad) {
      //console.log('[RealtimeVCU] YouTube URL sem alteração (cache válido)');
    }
  }

  /**
   * Processa mudança no VCU ID comparando com cache
   */
  private processVcuIdChange(newVcuId: string | null, isInitialLoad: boolean): void {
    const isValidVcuId = newVcuId && newVcuId !== 'null' && newVcuId.trim() !== '';
    const normalizedNewVcuId = isValidVcuId ? newVcuId : null;
    
    // Verificar se houve mudança comparando com o cache
    if (normalizedNewVcuId !== this.cachedVcuId) {
      //console.log('[RealtimeVCU] VCU ID alterado:', {
      //  antigo: this.cachedVcuId,
      //  novo: normalizedNewVcuId
      //});
      
      // Atualizar cache
      this.cachedVcuId = normalizedNewVcuId;
      
      // Atualizar estado
      if (isValidVcuId) {
        // Se mudou de um VCU para outro, desconectar o anterior
        if (this.dynamicVcuId && this.dynamicVcuId !== newVcuId) {
          //console.log('[RealtimeVCU] Desconectando do VCU anterior:', this.dynamicVcuId);
          this.telemetryService.disconnect();
        }
        
        this.dynamicVcuId = newVcuId;
        this.hasMapStream = true;
        //console.log('[RealtimeVCU] VCU ID atualizado:', this.dynamicVcuId);
        
        // Conectar ao SSE com o novo vcuId
        this.connectToVcuSSE();
        
        // Carregar histórico de coordenadas
        setTimeout(() => {
          this.loadCoordinatesHistory();
        }, 500);
      } else {
        // VCU ficou null - desconectar e mostrar placeholder
        if (this.dynamicVcuId) {
          //console.log('[RealtimeVCU] VCU ID removido, desconectando SSE');
          this.telemetryService.disconnect();
        }
        
        this.dynamicVcuId = null;
        this.hasMapStream = false;
        this.hasTransmission = false;
        //console.log('[RealtimeVCU] VCU ID é null, mostrando placeholder no mapa');
      }
    } else if (!isInitialLoad) {
      //console.log('[RealtimeVCU] VCU ID sem alteração (cache válido)');
    }
  }

  /**
   * Processa mudança no VCU ID 2 comparando com cache
   */
  private processVcuId2Change(newVcuId2: string | null, isInitialLoad: boolean): void {
    const isValidVcuId = newVcuId2 && newVcuId2 !== 'null' && newVcuId2.trim() !== '';
    const normalizedNewVcuId = isValidVcuId ? newVcuId2 : null;
    
    // Verificar se houve mudança comparando com o cache
    if (normalizedNewVcuId !== this.cachedVcuId2) {
      //console.log('[RealtimeVCU] VCU ID 2 alterado:', {
      //  antigo: this.cachedVcuId2,
      //  novo: normalizedNewVcuId
      //});
      
      // Atualizar cache
      this.cachedVcuId2 = normalizedNewVcuId;
      
      // Atualizar estado
      if (isValidVcuId) {
        this.dynamicVcuId2 = newVcuId2;
        //console.log('[RealtimeVCU] VCU ID 2 atualizado:', this.dynamicVcuId2);
        
        // Conectar ao SSE com o segundo vcuId (conexão independente)
        this.connectToVcuSSE2();
      } else {
        // Fechar conexão SSE do segundo VCU
        if (this.eventSource2) {
          this.eventSource2.close();
          this.eventSource2 = null;
        }
        
        this.dynamicVcuId2 = null;
        
        // Remover marker do segundo carro se existir
        if (this.marker2 && this.map) {
          this.map.removeLayer(this.marker2);
        }
        //console.log('[RealtimeVCU] VCU ID 2 é null');
      }
    } else if (!isInitialLoad) {
      //console.log('[RealtimeVCU] VCU ID 2 sem alteração (cache válido)');
    }
  }

  /**
   * Conecta ao SSE do segundo VCU usando EventSource direto
   * Não usa o SseService para evitar conflito com a conexão do primeiro VCU
   */
  private connectToVcuSSE2(): void {
    if (!this.dynamicVcuId2) {
      //console.warn('[RealtimeVCU] VCU ID 2 não definido');
      return;
    }
    
    // Fechar conexão anterior se existir
    if (this.eventSource2) {
      this.eventSource2.close();
      this.eventSource2 = null;
    }
    
    const vcuId2 = this.dynamicVcuId2;
    const url = `${enviroment.BASE_URL_SSE}/streaming/sse/stream/vcu/${vcuId2}`;
    
    //console.log('[RealtimeVCU] Conectando ao SSE do VCU 2:', vcuId2, url);
    
    try {
      this.eventSource2 = new EventSource(url);
      
      this.eventSource2.addEventListener('vcu-telemetry', (event: MessageEvent) => {
        try {
          const data = JSON.parse(event.data);
          this.processVcu2Data(data);
        } catch (error) {
          //console.error('[RealtimeVCU] Erro ao processar dados do VCU 2:', error);
        }
      });
      
      // Fallback para evento 'message'
      this.eventSource2.onmessage = (event: MessageEvent) => {
        try {
          const data = JSON.parse(event.data);
          this.processVcu2Data(data);
        } catch (error) {
          //console.error('[RealtimeVCU] Erro ao processar mensagem do VCU 2:', error);
        }
      };
      
      this.eventSource2.onopen = () => {
        //console.log('[RealtimeVCU] Conexão SSE do VCU 2 aberta');
      };
      
      this.eventSource2.onerror = (error) => {
        //console.error('[RealtimeVCU] Erro na conexão SSE do VCU 2:', error);
      };
      
    } catch (error) {
      //console.error('[RealtimeVCU] Falha ao criar EventSource para VCU 2:', error);
    }
  }

  /**
   * Processa dados recebidos do segundo VCU
   * Apenas atualiza posição no mapa, não atualiza telemetria
   */
  private processVcu2Data(data: any): void {
    // Extrair values da nova estrutura: data.data.samples[0].values
    let values: { [key: string]: number } | null = null;

    if (data?.data?.samples?.[0]?.values) {
      values = data.data.samples[0].values;
    } else if (data?.samples?.[0]?.values) {
      values = data.samples[0].values;
    }

    if (values) {
      // Coordenadas GPS
      const rawLatitude = values['GlobalInfo_GPS_Latitude'];
      const rawLongitude = values['GlobalInfo_GPS_Longitude'];

      if (rawLatitude && rawLongitude) {
        const newLatitude = this.convertToDecimalDegrees(rawLatitude, false);
        const newLongitude = this.convertToDecimalDegrees(rawLongitude, true);

        // Atualizar coordenadas do segundo VCU
        this._latitude2 = newLatitude;
        this._longitude2 = newLongitude;

        // Atualizar posição do segundo marker no mapa
        if (this._latitude2 !== 0 && this._longitude2 !== 0) {
          this.updateMapPosition2(this._latitude2, this._longitude2);
        }
      }
    }
  }

  /**
   * Atualiza a posição do segundo marker (VCU 2) no mapa
   */
  private updateMapPosition2(lat: number, lng: number): void {
    if (!this.map) return;
    
    const newLatLng = new L.LatLng(lat, lng);
    
    // Criar o segundo marker se não existir
    if (!this.marker2) {
      // Usar um ícone diferente para diferenciar do primeiro carro (cor preta)
      const customIcon2 = L.divIcon({
        html: `<div class="car-icon-wrapper">
                 <div class="car-icon-rotate" style="transform: rotate(0deg); width: 40px; height: 40px;">
                   <img src="assets/img/ftvelopark/carrito.svg" style="width: 100%; height: 100%; filter: brightness(0);">
                 </div>
               </div>`,
        iconSize: [40, 40],
        iconAnchor: [20, 20],
        popupAnchor: [0, -20],
        className: 'car-marker-icon car-marker-2'
      });

      this.marker2 = L.marker([lat, lng], {
        icon: customIcon2,
        rotationOrigin: 'center center'
      } as any).addTo(this.map);
      
      // Adicionar tooltip com nome do carro (aparece no hover)
      this.marker2.bindTooltip('Carro 2', {
        permanent: false,
        direction: 'bottom',
        offset: [0, 10],
        className: 'car-tooltip car-tooltip-2'
      });
      //console.log('[RealtimeVCU] Marker 2 criado na posição:', lat, lng);
    } else {
      // Calcular rotação do veículo baseado na direção do movimento
      if (this.previousCarPosition2) {
        const distance = this.previousCarPosition2.distanceTo(newLatLng);
        if (distance > 5) {
          const bearing = this.calculateBearing(this.previousCarPosition2, newLatLng);
          this.updateMarker2Rotation(bearing);
        }
      }
      
      // Atualizar posições
      this.previousCarPosition2 = this.currentCarPosition2;
      this.currentCarPosition2 = newLatLng;
      this.marker2.setLatLng(newLatLng);
    }
    
    // Atualizar posição anterior se for a primeira vez
    if (!this.currentCarPosition2) {
      this.currentCarPosition2 = newLatLng;
    }
  }

  /**
   * Atualiza a rotação visual do segundo marker
   */
  private updateMarker2Rotation(angle: number): void {
    if (this.marker2) {
      this.currentRotation2 = angle;
      
      const newIcon = L.divIcon({
        html: `<div class="car-icon-wrapper">
                 <div class="car-icon-rotate" style="transform: rotate(${angle}deg); width: 40px; height: 40px; transition: transform 0.3s ease;">
                   <img src="assets/img/ftvelopark/carrito.svg" style="width: 100%; height: 100%; filter: brightness(0);">
                 </div>
               </div>`,
        iconSize: [40, 40],
        iconAnchor: [20, 20],
        popupAnchor: [0, -20],
        className: 'car-marker-icon car-marker-2'
      });
      
      this.marker2.setIcon(newIcon);
    }
  }

  /**
   * Converte URL do YouTube para formato embed com autoplay
   * @param url URL do YouTube (pode ser watch, youtu.be ou já embed)
   * @returns URL no formato embed com parâmetros de autoplay
   */
  private convertToEmbedUrl(url: string): string {
    if (!url) return '';
    
    // Parâmetros para autoplay
    // autoplay=1 - inicia automaticamente
    // mute=1 - necessário para autoplay funcionar em navegadores modernos
    const autoplayParams = 'autoplay=1&mute=1';
    
    // Se já é um URL embed, adiciona parâmetros de autoplay
    if (url.includes('/embed/')) {
      const separator = url.includes('?') ? '&' : '?';
      return `${url}${separator}${autoplayParams}`;
    }
    
    // Extrair o video ID
    let videoId = '';
    
    // Formato: https://www.youtube.com/watch?v=VIDEO_ID
    if (url.includes('watch?v=')) {
      const urlParams = new URLSearchParams(url.split('?')[1]);
      videoId = urlParams.get('v') || '';
    }
    // Formato: https://youtu.be/VIDEO_ID
    else if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1]?.split('?')[0] || '';
    }
    // Formato: https://www.youtube.com/v/VIDEO_ID
    else if (url.includes('/v/')) {
      videoId = url.split('/v/')[1]?.split('?')[0] || '';
    }
    // Formato: https://www.youtube.com/live/VIDEO_ID
    else if (url.includes('/live/')) {
      videoId = url.split('/live/')[1]?.split('?')[0] || '';
    }
    
    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}?${autoplayParams}`;
    }
    
    // Se não conseguiu extrair, retorna o URL original
    return url;
  }

  toProjectSummary(
    project: GetAllPublicProjectsResponse
  ): ProjectSummaryResponse {
    var isFavorite = this.selectedFavoriteProjectIDs.includes(project.projectID);
    return new ProjectSummaryResponse(
      project.projectID, // projectID
      project.projectName, // projectName
      false, // default (valor padrão, ajustar se necessário)
      project.primaryImage?.[0]?.name ?? "", // primaryImage (assumindo que é o nome da imagem principal)
      project.userID, // sharedBy
      [], // tags (ajustar se vier de outro campo)
      [project.nickname], // nickname (transformado em array)
      project.attributes ?? undefined, // attributes
      project.userID ?? "", // ownerUser
      project.likes ?? 0, // likes
      [], // application (ajustar se necessário)
      "", // ownerUserName (ajustar se disponível)
      isFavorite
    );
  }

  getSelectedFavoriteProjectList(callback?: () => void): void {
    const userLogged = this.authService.getUserInformations();
    
    if (userLogged) {
      this.publicService
        .getSelectedFavoriteProjectList(userLogged)
        .subscribe({
          next: (data) => {
            this.selectedFavoriteProjectIDs = Object.values(data).map(
              (project) => project.projectID
            );
            if (callback) callback();
          },
          error: (error) => {
            //console.error("Erro ao carregar projetos favoritos:", error);
            if (callback) callback();
          },
        });
    } else {
      // Se não estiver logado, apenas executa o callback
      if (callback) callback();
    }
  }

  toggleFavoriteProject(projectID: string) {
    const userLogged = this.authService.getUserInformations();
    
    if (userLogged) {
      const updatedProjects = this.products().map((project: any) => {
        if (project.projectID === projectID) {
          project.isFavorite = !project.isFavorite;

          if (project.isFavorite) {
            project.likes += 1;
            this.selectedFavoriteProjectIDs.push(projectID);
          } else {
            this.selectedFavoriteProjectIDs =
              this.selectedFavoriteProjectIDs.filter((id) => id !== projectID);
            project.likes -= 1;
          }
        }
        return project;
      });
      this.products.set(updatedProjects);

      this.publicService
        .toggleFavoriteProject(projectID, userLogged)
        .subscribe(
          (data) => {
            Object.values(data).map((response) => {
              if (response === "successAdd") {
                this.messageService.clear();
                this.messageService.add({
                  key: "toastMessage",
                  severity: "success",
                  summary: this.translocoService.translate('messages.success.projectFavorited'),
                });
              } else if (response === "successRemove") {
                this.messageService.clear();
                this.messageService.add({
                  key: "toastMessage",
                  severity: "success",
                  summary: this.translocoService.translate('messages.success.projectUnfavorited'),
                });
              }
            });
          },
          (error) => {
            const revertedProjects = this.products().map((project: any) => {
              if (project.projectID === projectID) {
                project.isFavorite = !project.isFavorite;

                if (project.isFavorite) {
                  this.selectedFavoriteProjectIDs.push(projectID);
                } else {
                  this.selectedFavoriteProjectIDs =
                    this.selectedFavoriteProjectIDs.filter(
                      (id) => id !== projectID
                    );
                }
              }
              return project;
            });
            this.products.set(revertedProjects);
          }
        );
    }
  }

  goToPageProject(userID: string, projectID: string, projectName: string) {
    const userLogged = this.authService.getUserInformations();
    
    if (!userLogged) {
      this.messageService.add({
        key: "toastMessage",
        severity: "warn",
        summary: this.translocoService.translate('messages.error.loginRequired'),
      });
      return;
    } else {
      this.router.navigate([`/project/public/${projectName}`], {
        state: { userID, projectID },
      });
    }
  }

}
